"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROMOTION_START = exports.PROMOTION_END = exports.PROMOTION_CANCEL = void 0;
var PROMOTION_START = exports.PROMOTION_START = "PROMOTION_START";
var PROMOTION_END = exports.PROMOTION_END = "PROMOTION_END";
/** Postpone promotion, dont play it now. */
var PROMOTION_CANCEL = exports.PROMOTION_CANCEL = "PROMOTION_CANCEL";
//# sourceMappingURL=types.js.map